import React, { createContext, useContext, useEffect, useState, ReactNode } from "react";
import { getSettingsApi } from "../helpers/backend_helper"; // path adjust karo user-side mate

interface SiteSettings {
  site_name: string;
  site_tagline: string;
  logo_url: string;
  building_name: string;
  primary_color: string;
  accent_color: string;
  [key: string]: string;
}

const defaultSettings: SiteSettings = {
  site_name: "Loading...",
  site_tagline: "",
  logo_url: "",
  building_name: "",
  primary_color: "#1E3A5F",
  accent_color: "#E8AF30",
};

const SettingsContext = createContext<SiteSettings>(defaultSettings);

export const useSettings = () => useContext(SettingsContext);

export const SettingsProvider = ({ children }: { children: ReactNode }) => {
  const [settings, setSettings] = useState<SiteSettings>(defaultSettings);

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const res: any = await getSettingsApi();
        const data = res.settings;
        setSettings(data);

        // ✅ Browser tab title dynamic
        document.title = data.site_name + " || User Side";

        // ✅ Favicon dynamic (agar logo hoy to)
        if (data.logo_url) {
          const favicon = document.querySelector("link[rel='icon']") as HTMLLinkElement;
          if (favicon) {
            favicon.href = `${process.env.REACT_APP_API_URL}${data.logo_url}`;
          }
        }

        // ✅ CSS variables set karo — jethi primary/accent color badhe use thai shake
        document.documentElement.style.setProperty("--vz-primary", data.primary_color);
        document.documentElement.style.setProperty("--vz-warning", data.accent_color);
      } catch (err) {
        console.error("Settings load karva ma error:", err);
      }
    };

    loadSettings();
  }, []);

  return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>;
};